import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 商品列表
interface CommodityListData {
  token: string;
  id: string;
  game_id: string;
  server_id: string;
  page: number;
  limit: number;
  username: string;
  uid: string;
  status: string;
}

export const commodityList = (json: CommodityListData): any =>
  http.httpPost({
    url: httpApi.shopManage.commodityList,
    json,
  });

// 商品详情
interface CommodityDetailData {
  token: string;
  commodity_id: string;
}

export const commodityDetail = (json: CommodityDetailData): any =>
  http.httpPost({
    url: httpApi.shopManage.commodityDetail,
    json,
  });

// 商品下架
export const commodityShelfDown = (json: CommodityDetailData): any =>
  http.httpPost({
    url: httpApi.shopManage.commodityShelfDown,
    json,
  });

// 商品恢复上架
export const commodityResume = (json: CommodityDetailData): any =>
  http.httpPost({
    url: httpApi.shopManage.commodityResume,
    json,
  });

// 区服列表
interface ServerInfoData {
  token: string;
  game_id: string;
}

export const serverInfo = (json: ServerInfoData): any =>
  http.httpPost({
    url: httpApi.shopManage.serverInfo,
    json,
  });

// 商品导出excel
interface CommodityExcelData {
  id: string;
  game_id: string;
  server_id: string;
}

export const commodityExcel = (json: CommodityExcelData): any =>
  http.httpGet({
    url: httpApi.shopManage.commodityExcel,
    json,
  });

// 商品导出excel
interface ShieldData {
  token: string;
  commodity_id: string;
  type: number;
}

export const shield = (json: ShieldData): any =>
  http.httpPost({
    url: httpApi.shopManage.shield,
    json,
  });

// 商品失效
interface InvalidParams {
  commodity_id: string;
}

export const apiInvalid = (json: InvalidParams): any =>
  http.httpPost({
    url: httpApi.shopManage.invalid,
    json,
  });
